import React, { useEffect } from 'react'

import { upsertOneWidgetWindow } from '@/entities/widgetWindows'
import { CustomGridToolbar } from '@/shared/components/GridTable/CustomGridToolbar'
import { GridTable } from '@/shared/components/GridTable/GridTable'
import { TREE_WIDGETS, WidgetTypeWithSuffix } from '@/shared/components/Mosaic/models/widgetType'
import { useAppDispatch } from '@/shared/store'

import { useRunsSummaryTableData } from './libs/useRunsSummaryTableData'
import { useSummaryTableData } from './libs/useSummaryTableData'
import { useSummaryTableContext } from './SummaryTableContext'

export type SummaryTableProps = {
  id: string // Runsheet or Scenario Id
  widgetId: WidgetTypeWithSuffix // Widget Window id
  layoutType: 'planning' | 'runsheet'
}

export const SummaryTable: React.FC<SummaryTableProps> = ({ id, widgetId, layoutType }) => {
  const { showSummaryTable } = useSummaryTableContext()
  const { loading, summaryRows, summaryColumns } = useSummaryTableData(id, layoutType, showSummaryTable)
  const { scheduleName, shifts, runColumns, runColumnGroupingModel } = useRunsSummaryTableData(id, layoutType)

  const dispatch = useAppDispatch()

  // Update widget window context and global store to render widow title, uiColor, etc.
  useEffect(() => {
    if (!widgetId) return
    
    dispatch(upsertOneWidgetWindow({
      id: widgetId,
      scenarioId: id,
      isActive: true,
      widgetType: TREE_WIDGETS.ScenarioSummaryTable,
      navigations: [
        {
          title: `${scheduleName}`,
        },
      ],
    }))
  }, [widgetId, dispatch, scheduleName, id])

  return showSummaryTable ? (
    <GridTable
      rows={summaryRows}
      columns={summaryColumns}
      loading={loading}
      isDragDropEnabled={false}
      slots={{
        toolbar: CustomGridToolbar,
      }}
      sx={{
        '.MuiDataGrid-filler--pinnedRight': { display: 'none' },
      }}
    />
  ) : (
    <GridTable
      rows={shifts}
      columns={runColumns}
      columnGroupingModel={runColumnGroupingModel}
      loading={loading}
      isDragDropEnabled={false}
      slots={{
        toolbar: CustomGridToolbar,
      }}
      sx={{
        '.MuiDataGrid-filler--pinnedRight': { display: 'none' },
      }}
    />
  )
}
